import { createFileRoute } from "@tanstack/react-router";
import { ServicePageTemplate } from "@/components/ServicePageTemplate";
import { getService } from "@/data/services";
import { SITE_URL, canonical, seoCanonicalLink, seoOgUrl } from "@/lib/seo";

const service = getService("managed-it")!;

export const Route = createFileRoute("/services_/managed-it-services")({
  component: () => <ServicePageTemplate service={service} />,
  head: () => ({
    meta: [
      { title: "Managed IT Services — SimpleTech" },
      {
        name: "description",
        content:
          "Proactive managed IT that keeps your team productive and systems stable — practical monitoring, maintenance, and support for growing businesses.",
      },
      { property: "og:title", content: "Managed IT Services — SimpleTech" },
      {
        property: "og:description",
        content: "Reduce downtime and improve security with managed IT from SimpleTech.",
      },
      seoOgUrl("/services/managed-it-services"),
    ],
    links: [seoCanonicalLink("/services/managed-it-services")],
  }),
});
